declare var $: any;

export class StartPage {
    static init() {
        $(".js-local-login-form-toggle-button").on("click", StartPage.handleToggleLocalLoginForm);
    }

    static handleToggleLocalLoginForm(e: Event) {
        e.preventDefault();
        $(".local-login-form").slideToggle();

        return false;
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/partials/startPage.ts